import { PropsWithChildren } from 'react';
import { Trans } from 'react-i18next';

import Icons from '@/core/components/Icons';
import Store from '@/core/lib/new-architecture/store';

interface ContributionCardProps extends PropsWithChildren {}

const ContributionCard: React.FC<ContributionCardProps> = ({ children }) => {
  const { data: current } = Store.current.useCurrent();
  const i18nKey = !current || current.displayAds() ? 'contribution-menu-card.title' : 'contribution-menu-card.title-already-contribute';

  return (
    <div className="w-full rounded-2 border-[1.5px] border-brand-500 bg-brand-50 p-3">
      <div className={`text-body-secondary flex ${children ? 'justify-start' : 'justify-center'} font-semibold ${children ? 'mb-2' : ''}`}>
        <Icons icon="heart-check" color="foundation" className="mr-2" />
        <div className="flex flex-col">
          <p>
            <Trans i18nKey={i18nKey} ns="contribute" components={[<span key="contribute" className="text-brand-500" />]} />
          </p>
          {current && current.nbDaysWithoutAdsRemaining > 0 && (
            <p>
              <Trans
                i18nKey="contribution-menu-card.time-left-without-ads"
                ns="contribute"
                count={current?.nbDaysWithoutAdsRemaining}
                values={{ nbDaysWithoutAdsRemaining: current.nbDaysWithoutAdsRemaining }}
                components={[<span key="contribute" className="text-brand-500" />]}
              />
            </p>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default ContributionCard;
